import React, {useState, useEffect} from 'react'
import {useLocation, useHistory, useParams} from 'react-router'
import {LoadEffect}  from '../component/loader'
import axios from 'axios'
import { Alerts } from '../component/notify'
import PageHeader from '../component/pageheader'
import {ServerUrl, ImagesUrl, Token,  config} from '../component/include'
import {backgroungImage} from '../component/images'
import Select from 'react-select'
import { userToken } from '../component/authentication'
import Error403 from '../settings/error403'
import { verifyRouter } from '../component/authentication'
import { useSelector } from 'react-redux'

const StaffProfile =()=>{
    let history = useHistory();
    let params = useParams()

    const [notice, setNotice] = useState({
        isLoading : false, 
        isDataFetching: false,
    });
    
    const [staff, setStaff] = useState([]);
    const [position, setPosition]=useState([])
    const [department, setDepartment]=useState([])

    const [profile, setProfile]=useState({
        staff:[]
    });

    let location =  useLocation()
    const [isAuthenticated, setIsAuthenticated] = useState(true);
    const allStaff  = useSelector(state => state.rootReducer.staff);

    const fetchDepartment =()=>{
        const fd = new FormData();
        fd.append('jwt', Token); 
        let url = ServerUrl + '/fetchField/tbl_staff_settings/department/ID/1'
        axios.post(url, fd, config)
        .then(result =>setDepartment(result.data))
    }

    const fetchPosition =()=>{
        const fd = new FormData();
        fd.append('jwt', Token); 
        let url = ServerUrl + '/fetchField/tbl_staff_settings/position/ID/1'
        axios.post(url, fd, config)
        .then(result =>setPosition(result.data))
    }
    const getPosition =(code)=>{
        const answer =  position.filter(item=>item.code===code)
        const reply = answer.length!==0?answer[0].positionName:''
        return reply
    }


    const getDepartment =(code)=>{
        const result = department.filter(item=>item.code===code);
        const answer = result.length!==0?result[0].departmentName:''
        return  answer
    }

    const handleSelect = (option, action)=>{
        setProfile({...profile, [action.name]: option});
    }
   
    const handleFetchStaff =(code)=>{
        setNotice({...notice, isLoading: true})
        var sql ="Select *  from tbl_staff where code ='"+code+"' "; 
        const fd = new FormData();
        fd.append('jwt', Token); 
        fd.append("sql", sql);
        let url = ServerUrl+'/fetchBySql_controller'
        axios.post(url, fd, config).then(result=>setStaff(result.data))
        .catch((error)=>{
            Alerts('Error!', 'danger', error.message)
        }).finally(()=>{
            setNotice({...notice, 
                isLoading: false})
        })
    }
    

    useEffect(()=>{   
        //setIsAuthenticated(verifyRouter(location.pathname))
        fetchDepartment();
        fetchPosition();
        handleFetchStaff(params.code)
    },[]);

    return (  <>
        <div  className="main-body">
            {isAuthenticated ? <div className="page-wrapper">
                {notice.isLoading ? <LoadEffect className="overlay floatLoad" /> : "" }

                <PageHeader title="Staff Profile">
                    <li className="breadcrumb-item"><a href="#!"> <i className="feather icon-home"></i> </a></li>
                    <li className="breadcrumb-item"><a href="#!">Staff</a></li>
                    <li className="breadcrumb-item"><a href="#!">Profile</a></li>
                </PageHeader>
                
                {/* The Page Body start here */}
                <div className="page-body">
                    {/* Staff Selection Card */}
                    <div className="row no-print">
                        <div className="col-sm-12">
                            <div className="card shadow-sm">
                                <div className="card-header bg-light">
                                    <h5><i className="fa fa-user-circle mr-2"></i> Select Staff</h5>
                                    <div className="card-header-right">
                                        <ul className="list-unstyled card-option">
                                            <li><i className="feather icon-maximizes full-card"></i></li>
                                            <li><i className="feather icon-minus minimize-card"></i></li>
                                            <li><i className="feather icon-trash-2 close-card"></i></li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="card-block p-4">
                                    <div className="row">
                                        <div className="col-md-9">
                                            <div className="form-group">
                                                   <Select  
                                                    options={allStaff && allStaff.map((list, idx) => {
                                                        return {key: idx, value: list.code, label: list.staffName, fileNo: list.fileNo}
                                                    })}
                                                    getOptionLabel={option => option.label + ' - ' + option.fileNo}    
                                                    onChange={handleSelect}  
                                                    name="staff" 
                                                    value={profile.staff}
                                                    className="mb-3"
                                                    placeholder="Search for staff..."
                                                    isClearable
                                                />   
                                            </div>
                                        </div>
                                        <div className="col-md-3 form-group">
                                            <button 
                                                type="button"  
                                                onClick={() => handleFetchStaff(profile.staff.value)} 
                                                className="btn btn-primary btn-block shadow-sm " 
                                                disabled={!profile.staff || !profile.staff.value}
                                            >
                                                <i className="fa fa-search mr-2"></i> View Profile
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Staff Profile Display */}
                    {staff.length !== 0 ? staff.map((item, idx) => (
                        <div key={idx} className="row">
                            <div className="col-lg-12 mb-4">
                                {/* Profile Header Card */}
                                <div className="card shadow-sm border-0">
                                    <div className="profile-header" style={{backgroundImage: `url(${backgroungImage})`, backgroundSize: 'cover', backgroundPosition: 'center', height: '180px', position: 'relative', borderRadius: '0.25rem 0.25rem 0 0'}}>
                                        <div className="profile-overlay" style={{position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.5)', borderRadius: '0.25rem 0.25rem 0 0'}}></div>
                                    </div>
                                    
                                    <div className="card-body pt-0">
                                        <div className="row">
                                            <div className="col-lg-12 text-center">
                                                {/* Profile Image */}
                                                <div className="profile-image-container" style={{marginTop: '-75px', marginBottom: '20px'}}>
                                                    <img 
                                                        className="profile-image rounded-circle border border-4 border-white shadow" 
                                                        onError={(e) => {e.target.onerror = null; e.target.src=ImagesUrl+'/staff/'+item.gender+'.png'}} 
                                                        src={ImagesUrl+'/staff/'+item.passport} 
                                                        alt={item.staffName} 
                                                        style={{height: '150px', width: '150px', objectFit: 'cover'}} 
                                                    />
                                                </div>
                                                {/* Profile Title */}
                                                <div className="profile-title mb-4">
                                                    <h2 className="mb-1 font-weight-bold">{item.staffName}</h2>
                                                    <h5 className="text-muted">{getPosition(item.position)}</h5>
                                                    <div className="mt-2">
                                                        <span className={`badge ${item.employmentStatus === 'Working' ? 'badge-success' : 'badge-danger'} p-2`}>
                                                            {item.employmentStatus}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                
                                {/* Information Cards Row */}
                                <div className="row mt-4">
                                    {/* Personal Information Card */}
                                    <div className="col-lg-6 col-md-6 mb-4">
                                        <div className="card h-100 border-0 shadow-sm">
                                            <div className="card-header bg-primary text-white">
                                                <h5 className="mb-0"><i className="fa fa-user-circle mr-2"></i> Personal Information</h5>
                                            </div>
                                            <div className="card-body">
                                                <ul className="list-group list-group-flush">
                                                    <li className="list-group-item d-flex justify-content-between align-items-center border-0 px-0 pb-3">
                                                        <div>
                                                            <i className="fa fa-calendar-alt mr-2 text-primary"></i> Birth Date
                                                        </div>
                                                        <span className="text-muted">{item.birthDate}</span>
                                                    </li>
                                                    <li className="list-group-item d-flex justify-content-between align-items-center border-0 px-0 pb-3">
                                                        <div>
                                                            <i className="fa fa-calendar-alt mr-2 text-primary"></i> Date of Joining
                                                        </div>
                                                        <span className="text-muted">{item.joinDate}</span>
                                                    </li>
                                                    <li className="list-group-item d-flex justify-content-between align-items-center border-0 px-0 pb-3">
                                                        <div>
                                                            <i className="fa fa-user mr-2 text-primary"></i> Father's Name
                                                        </div>
                                                        <span className="text-muted">{item.fatherName}</span>
                                                    </li>
                                                    <li className="list-group-item d-flex justify-content-between align-items-center border-0 px-0 pb-3">
                                                        <div>
                                                            <i className="fa fa-user mr-2 text-primary"></i> Mother's Name
                                                        </div>
                                                        <span className="text-muted">{item.motherName}</span>
                                                    </li>
                                                    <li className="list-group-item d-flex justify-content-between align-items-center border-0 px-0 pb-3">
                                                        <div>
                                                            <i className="fa fa-briefcase mr-2 text-primary"></i> Position
                                                        </div>
                                                        <span className="text-muted">{getPosition(item.position)}</span>
                                                    </li>
                                                    <li className="list-group-item d-flex justify-content-between align-items-center border-0 px-0">
                                                        <div>
                                                            <i className="fa fa-building mr-2 text-primary"></i> Department
                                                        </div>
                                                        <span className="text-muted">{getDepartment(item.department)}</span>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    
                                    {/* Contact Information Card */}
                                    <div className="col-lg-6 col-md-6 mb-4">
                                        <div className="card h-100 border-0 shadow-sm">
                                            <div className="card-header bg-info text-white">
                                                <h5 className="mb-0"><i className="fa fa-envelope mr-2"></i> Contact Information</h5>
                                            </div>
                                            <div className="card-body">
                                                <ul className="list-group list-group-flush">
                                                    <li className="list-group-item d-flex justify-content-between align-items-center border-0 px-0 pb-3">
                                                        <div>
                                                            <i className="fa fa-phone mr-2 text-info"></i> Mobile
                                                        </div>
                                                        <span className="text-muted">{item.mobile}</span>
                                                    </li>
                                                    <li className="list-group-item d-flex justify-content-between align-items-center border-0 px-0 pb-3">
                                                        <div>
                                                            <i className="fa fa-phone mr-2 text-info"></i> Alternative Mobile
                                                        </div>
                                                        <span className="text-muted">{item.altMobile}</span>
                                                    </li>
                                                    <li className="list-group-item d-flex justify-content-between align-items-center border-0 px-0 pb-3">
                                                        <div>
                                                            <i className="fa fa-envelope mr-2 text-info"></i> Email
                                                        </div>
                                                        <span className="text-muted" style={{wordBreak: 'break-word'}}>{item.email}</span>
                                                    </li>
                                                    <li className="list-group-item d-flex justify-content-between align-items-center border-0 px-0">
                                                        <div>
                                                            <i className="fa fa-id-card mr-2 text-info"></i> Username
                                                        </div>
                                                        <span className="text-muted">{item.username}</span>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                
                                {/* Address Information Card */}
                                <div className="row">
                                    <div className="col-lg-12 mb-4">
                                        <div className="card border-0 shadow-sm">
                                            <div className="card-header bg-secondary text-white">
                                                <h5 className="mb-0"><i className="fa fa-map-marker-alt mr-2"></i> Address Information</h5>
                                            </div>
                                            <div className="card-body">
                                                <div className="row">
                                                    <div className="col-md-6 mb-3 mb-md-0">
                                                        <h6 className="text-primary">Present Address</h6>
                                                        <p className="text-muted">{item.presentAddress}</p>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <h6 className="text-primary">Permanent Address</h6>
                                                        <p className="text-muted">{item.permanentAddress}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                
                                {/* Print Button */}
                                <div className="row">
                                    <div className="col-12 text-center">
                                        <form method='POST' action={ServerUrl+'/printout/staff_profile.php?token='+userToken} target='_blank'>
                                            <input type='hidden' name='staffCode' value={item.code} />
                                            <input type='hidden' name='jwtToken' value={Token} />
                                            <button type="submit" className="btn btn-primary btn-lg no-print shadow-sm">
                                                <i className="fa fa-print mr-2"></i> Print Profile
                                            </button>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )) : ''}
                </div>
            </div> : <Error403 />}
        </div>
    </> 
    );
}

export default React.memo(StaffProfile)